import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.#focusInput(this.inputTarget);
    console.log("connect controller");
    if (this.inputTarget.dataset.unlockFocus == "true") {
      console.log("input target unlock focus is true");
      document.addEventListener("click", (e)=>{
        console.log("add listener");
        if (document.activeElement != this.inputTarget && document.activeElement.dataset.keepFocus != "true") {
          this.#focusInput(this.inputTarget);
        }
      })
    }
  }

  #focusInput(input) {
    console.log("set readonly to true");
    input.readOnly = true;
    input.focus()
    console.log("focus input");
    setTimeout(function(){
      input.readOnly = false;console.log("readOnly is false");}, 50);
  }
}
